module.exports = "<h2>How much money is in each account?</h2> <crud-clerk-account-balance-curate></crud-clerk-account-balance-curate> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/subsections/financial-events/inspect.financial-events.account-balances.html
// module id = 4157
// module chunks = 86